import { Stats } from 'shared/models';
import apiClient from '../utils/apiClient';

/**
 * Service for accessing application statistics data
 */
const statsService = {
  /**
   * Get global application statistics
   * @returns {Promise<Stats>} The global stats object
   */
  async getGlobalStats() {
    try {
      const response = await apiClient.get('/api/stats');
      return new Stats(response.data.stats || response.data);
    } catch (error) {
      console.error('Error fetching global stats:', error);
      // Return empty stats object instead of throwing
      return new Stats();
    }
  }
};

export default statsService;